export default __webpack_public_path__ + "static/media/Capacity Building.ff41da70.svg";